export const AMERIKOOLER_THEME = 'amerikooler-theme';
export const DARK_DEEP_ORANGE = 'dark-deep-orange';
